/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddedDocument } from './AddedDocument'

export class Verse {
  constructor(json: JSON | any) {
    Object.assign(this as Verse, json)
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object. Filled automatically when deletePatient is called.
   */
  deletionDate?: number
  chapterName?: string
  paragraphName?: string
  verseSeq?: number
  startDate?: number
  createdTms?: number
  createdUserId?: string
  endDate?: number
  verseNum?: number
  verseSeqParent?: number
  verseLevel?: number
  verseType?: string
  checkBoxInd?: string
  minCheckNum?: number
  andClauseNum?: number
  textFr?: string
  textNl?: string
  requestType?: string
  agreementTerm?: number
  agreementTermUnit?: string
  maxPackageNumber?: number
  purchasingAdvisorQualList?: string
  legalReference?: string
  modificationDate?: number
  addedDocuments?: Array<AddedDocument>
  agreementYearMax?: number
  agreementRenewalMax?: number
  sexRestricted?: string
  minimumAgeAuthorized?: number
  maximumAgeAuthorized?: number
  maximumContentQuantity?: number
  maximumContentUnit?: string
  maximumStrengthQuantity?: number
  maximumStrengthUnit?: string
  maximumDurationQuantity?: number
  maximumDurationUnit?: string
  otherAddedDocumentInd?: string
  minimumAgeAuthorizedUnit?: string
  maximumAgeAuthorizedUnit?: string
  modificationStatus?: string
  children?: Array<Verse>
}
